import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type PathContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, status: Types.ResourceStatusEnum, description?: string | null, bookmark?: { id: string } | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type PathContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type PathContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, status: Types.ResourceStatusEnum, description?: string | null, bookmark?: { id: string } | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type PathContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const PathContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment PathContentCard on PathContentType {
  id
  name
  type
  duration
  description: objective
  status
  bookmark {
    id
  }
  cover {
    ...EntityMedia
  }
  performance {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;
export const PathContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment PathContentCardWithUserPerformance on PathContentType {
  id
  name
  type
  duration
  description: objective
  status
  bookmark {
    id
  }
  cover {
    ...EntityMedia
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;